import imageBar from "../../assets/imageBar.png";

const ImageBar = () => {
  return <img src={imageBar} alt="" className="hidden md:block w-full" />;
};

export default ImageBar;
